import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { RiTwitterFill } from 'react-icons/ri'
import { ImLinkedin, ImFacebook } from 'react-icons/im'
import { GrFormNextLink, GrClose } from 'react-icons/gr'
import { GiHamburgerMenu } from 'react-icons/gi'
import './styles.css'

export default function LandingWrapper({ children }) {
    const [showMenu, setShowMenu] = useState(false)

    // if showMenu disable scroll on body
    if (showMenu) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = 'auto'
    }

    const redirectLogo = () => {
        window.location.href = '/'
    }
    
    return (
        <div>
            <MenuResponsive showMenu={showMenu} />
            <div className='landing-home__header'>
                <img src="https://dkbsign.com/logo.png" onClick={redirectLogo} alt="logo-header_landing" className='logo-header_landing' />
                <a className='logo-header_menu' href="/">ACCUEIL</a>
                <a className='logo-header_menu' href="/home-product">PRODUITS</a>
                <a className='logo-header_menu' href="/home-solution">SOLUTIONS</a>
                <a className='logo-header_menu' href="/home-api">API</a>
                <a className='logo-header_menu' href="/home-token">TOKEN</a>
                <a className='logo-header_menu' href="/home-plateform">PLATEFORM</a>
                <a className='logo-header_menu' href="/home-tarif">TARIF</a>
                <a className='logo-header_menu' href="/home-reference">REFERENCE</a>
                <a className='logo-header_menu' href="/home-apropos">A PROPOS</a>
                {
                    showMenu ? 
                    <GrClose onClick={()=> setShowMenu(false)} className='logo-hamburger' color={'black'} size={24} /> : 
                    <GiHamburgerMenu onClick={()=> setShowMenu(true)} className='logo-hamburger' color={'black'} size={24} />
                }
                <a className='logo-header_tel' href="tel:+2252722464724">+225 27 22 46 47 24</a>
                <a className='logo-header_menu' href="/">FR</a>
                <div className="dropdown-menu-clientspac">
                    <a className='logo-header_menu'>ESPACE CLIENT</a>
                    <div className="dropdown-menu-clientspac-content">
                        <a className='logo-header_menu' target='_blank' href="https://dkbsign.com/login">Connexion</a>
                        {/* <a className='logo-header_menu' href="#">Inscription</a> */}
                    </div>
                </div>
            </div>
            {children}
            <div className="landing-footer">

                <div style={{ flexDirection: 'row', position: 'relative', top: '20%' }} className="landing-footer__menu-newsletter">
                    <div className="landing-footer__newsletter">
                        <h5 className="landing-footer__newsletter_title">INSCRIVEZ-VOUS A LA NEWSLETTER</h5>
                        <div className='__newsletter_input'>
                            <input className="landing-footer__newsletter_input" type="text" placeholder="Votre adresse email" />
                            <GrFormNextLink className='__newsletter_input_next' color='white' size={25} />
                        </div>

                    </div>
                    <div className="social-network-newsletter">
                        <a className='landing-footer__menu_items' target='_blank' href="https://twitter.com/dkbscertafrique">
                            <RiTwitterFill style={{ marginRight: 12 }} color='white' size={25} />
                            Twitter
                        </a>
                        <a className='landing-footer__menu_items' target='_blank' href="https://www.linkedin.com/company/dkbs-certafrique/mycompany">
                            <ImLinkedin style={{ marginRight: 12 }} color='white' size={25} />
                            Linkedin
                        </a>
                        <a className='landing-footer__menu_items' target='_blank' href="https://www.facebook.com/DKBSCertAfrique/?locale=fr_FR">
                            <ImFacebook style={{ marginRight: 12 }} color='white' size={25} />
                            Facebook
                        </a>
                    </div>
                </div>
                <div className="landing-footer__content">
                    <div style={{position: 'relative', left: '9%'}} className="landing-footer__menu">
                        <a className='landing-footer__menu_items' href="/">ACCUEIL</a>
                        <a className='landing-footer__menu_items' href="/home-product">PRODUITS</a>
                        <a className='landing-footer__menu_items' href="/home-solution">SOLUTIONS</a>
                        <a className='landing-footer__menu_items' href="/home-api">API</a>
                        <a className='landing-footer__menu_items' href="/home-token">TOKEN</a>
                        <a className='landing-footer__menu_items' href="/home-plateform">PLATEFORM</a>
                    </div>
                    <div style={{ position: 'relative', bottom: '11%' }} className="landing-footer__menu">
                        <a className='landing-footer__menu_items' href="/home-tarif">TARIF</a>
                        <a className='landing-footer__menu_items' href="/home-reference">REFERENCE</a>
                        <a className='landing-footer__menu_items' href="/home-apropos">A PROPOS</a>
                    </div>
                    <div className="landing-footer__img-cont">
                        <img className="landing-footer__img" src="https://dkbsign.com/assets/media/home_icon/NewLogoDKBSign1.png" alt="logo" />
                        <p className="landing-footer__img-cont-txt">DKBSign est une plateforme mise à la disposition des utilisateurs pour leur permettre de faire de la signature électronique afin de conférer une valeur juridique légale aux documents signés. DKBSign est un produit de DKB Solutions tiers de confiance agréé par l'ARTCI, engagé à garantir la sécurité, la confidentialité, l'intégrité des transactions sur internet</p>
                    </div>
                </div>

                <p className="landing-footer_copyrigth">Copyrigth © DKBSign 2017 | All Rigths Reserved by DKB Solutions</p>
            </div>
        </div>
    )
}

const MenuResponsive = ({showMenu}) => {
    return (
        <div className={showMenu ? 'landing-home__header__menu-responsive-display' : 'landing-home__header__menu-responsive'}>
            <Link className='logo-header_menu-responsive' to="/">ACCEUIL</Link>
            <Link className='logo-header_menu-responsive' to="/home-product">PRODUITS</Link>
            <Link className='logo-header_menu-responsive' to="/home-solution">SOLUTIONS</Link>
            <Link className='logo-header_menu-responsive' to="/home-api">API</Link>
            <Link className='logo-header_menu-responsive' to="/home-token">TOKEN</Link>
            <Link className='logo-header_menu-responsive' to="/home-plateform">PLATEFORM</Link>
            <Link className='logo-header_menu-responsive' to="/home-tarif">TARIF</Link>
            <Link className='logo-header_menu-responsive' to="/home-reference">REFERENCE</Link>
            <Link className='logo-header_menu-responsive' to="/home-apropos">A PROPOS</Link>
        </div>
    )
}